import { Box, SegmentedControl } from "@primer/react";
import { Button as DevButton } from 'devextreme-react/button';
import moment from 'moment';
import { useCallback, useEffect, useMemo, useState } from "react";
import { hinhThucMienGiamApi } from "../../../api/hinhThucMienGiamApi";
import { thuPhiApi } from "../../../api/thuPhiApi";
import { showNotify } from "../../../helpers/toast";
import { sf_hinhthucmiengiam } from "../../../models/response/category/sf_hinhthucmiengiam";
import { sf_mucphaithu } from "../../../models/response/thu-phi/sf_mucphaithu";
import { sf_mucphaithu_miengiam } from "../../../models/response/thu-phi/sf_mucphaithu_miengiam";
import { Button } from "../../buttons";
import DataGrid from "../../data-grid/DataGrid";
import { IDataGridColumn } from "../../data-grid/type/IDataGridProps";
import { DefaultPopup } from "../../modal";
export type ThuPhiDieuChinhChietKhauBtnProps = {
    disabled: boolean,
    sf_mucphaithu: sf_mucphaithu,
    onChanged: () => void,
    ts_hocsinh: any
}
const ThuPhiDieuChinhChietKhauBtn = (props: ThuPhiDieuChinhChietKhauBtnProps) => {
    const [isShowModal, setIsShowModal] = useState<boolean>(false);
    return (
        <>
            <DevButton
                text="Điều chỉnh chiết khấu"
                type="default"
                stylingMode="text"
                icon="plus"
                className="p-btn-devextreme"
                disabled={props.disabled}
                onClick={() => {
                    setIsShowModal(true);
                }}
            />
            {isShowModal && <ThuPhiAddMienGiamModal
                onClose={() => { setIsShowModal(false) }}
                sf_mucphaithu={props.sf_mucphaithu}
                onChanged={() => {
                    setIsShowModal(false);
                    props.onChanged();
                }}
                ts_hocsinh={props.ts_hocsinh}
            />}
        </>
    )
}
type ThuPhiAddMienGiamModalProps = {
    sf_mucphaithu: sf_mucphaithu,
    onClose: () => void,
    onChanged: () => void
    ts_hocsinh: any
}

const ThuPhiAddMienGiamModal = (props: ThuPhiAddMienGiamModalProps) => {
    const [sf_hinhthucmiengiams, set_sf_hinhthucmiengiams] = useState<sf_hinhthucmiengiam[]>([])
    const [sf_hinhthucmiengiam_selected_ids, set_sf_hinhthucmiengiam_selected_ids] = useState<number[]>([])
    const [sf_mucphaithu_miengiams, st_sf_mucphaithu_miengiams] = useState<sf_mucphaithu_miengiam[]>([])
    const [isSaving, SetIsSaving] = useState<boolean>(false)
    const [statusFilter, setStatusFilter] = useState<number>(0);

    const columns: IDataGridColumn[] = useMemo(() => [
        {
            dataField: "ma_hinh_thuc",
            caption: "Mã hình thức",
            width: 100,
        },
        {
            dataField: "hinh_thuc_mien_giam",
            caption: "Hình thức miễn giảm",
            minWidth: 250,
        },
        {
            dataField: "tu_ngay",
            caption: "Ngày bắt đầu",
            width: 100,
            cellRender: (data: any) => data.tu_ngay ? moment(data.tu_ngay).format("DD/MM/YYYY") : ""
        },
        {
            dataField: "den_ngay",
            caption: "Ngày kết thúc",
            width: 100,
            cellRender: (data: any) => data.den_ngay ? moment(data.den_ngay).format("DD/MM/YYYY") : ""
        },
        {
            caption: "Trạng thái",
            width: 120,
            cellRender: (data: any) => {
                if (data.isGroupHeader) return null;
                const now = moment();
                if (data.tu_ngay && moment(data.tu_ngay).isAfter(now, 'day')) {
                    return <span style={{ color: "orange" }}>Sắp diễn ra</span>
                }
                if (data.den_ngay && moment(data.den_ngay).isBefore(now, 'day')) {
                    return <span style={{ color: "red" }}>Hết hạn</span>
                }
                return <span style={{ color: "green" }}>Khả dụng</span>
            }
        },
        {
            dataField: "ten_nhom_mien_giam",
            caption: "Nhóm miễn giảm",
            isVisible: false
        }
    ], [])

    useEffect(() => {
        handleReloadMucPhaiThuMienGiams()
    }, [props.sf_mucphaithu.id])
    useEffect(() => {
        handleReloadHinhThucMienGiams()
    }, [])

    const handleReloadHinhThucMienGiams = async () => {
        const res = await hinhThucMienGiamApi.select(props.sf_mucphaithu.nam_hoc)
        if (res.is_success) {
            const filteredData = res.data.filter((c: any) => {
                const isCosoMatch = c.dm_coso_id === props.ts_hocsinh.dm_coso_id;
                return isCosoMatch;
            }).sort((a: any, b: any) => a.sf_hinhthucmiengiam_group_id - b.sf_hinhthucmiengiam_group_id);
            set_sf_hinhthucmiengiams(filteredData);
        }
    }

    const handleReloadMucPhaiThuMienGiams = async () => {
        const res = await thuPhiApi.select_miengiam(props.sf_mucphaithu.id)
        if (res.is_success && res.data) {
            st_sf_mucphaithu_miengiams(res.data)
            set_sf_hinhthucmiengiam_selected_ids(res.data.map((x: sf_mucphaithu_miengiam) => x.sf_hinhthucmiengiam_id))
        }
    }
    const onSelectionChanged = (selectedRowKeys: any[]) => {
        const updatedSelectedKeys = [...selectedRowKeys];
        for (let i = updatedSelectedKeys.length - 1; i >= 0; i--) {
            const sf_hinhthucmiengiam_id = updatedSelectedKeys[i];

            if (sf_hinhthucmiengiam_id > 0) {
                const sf_hinhthucmiengiam = sf_hinhthucmiengiams.filter(x => x.id === sf_hinhthucmiengiam_id)[0];
                const nhom_mien_giam = sf_hinhthucmiengiam.nhom_mien_giam;
                const sf_hinhthucmiengiam_cung_nhoms = sf_hinhthucmiengiams.filter(x => x.nhom_mien_giam === nhom_mien_giam && x.id !== sf_hinhthucmiengiam_id);
                for (let j = 0; j < sf_hinhthucmiengiam_cung_nhoms.length; j++) {
                    const sf_hinhthucmiengiam_cung_nhom_id = sf_hinhthucmiengiam_cung_nhoms[j].id;
                    for (let k = 0; k < i; k++) {
                        if (updatedSelectedKeys[k] === sf_hinhthucmiengiam_cung_nhom_id) {
                            updatedSelectedKeys.splice(k, 1);
                            i--; // Adjust index after splice
                        }
                    }
                }
            }
        }

        const selectd_ids = updatedSelectedKeys.filter((x: number) => x > 0);
        set_sf_hinhthucmiengiam_selected_ids(selectd_ids);
    }
    const dataSource = useMemo(() => {
        let displayData = [...sf_hinhthucmiengiams];
        const now = moment();

        if (statusFilter === 1) { // Khả dụng
            displayData = displayData.filter((x) => {
                const start = x.tu_ngay ? moment(x.tu_ngay) : null;
                const end = x.den_ngay ? moment(x.den_ngay) : null;
                return (!start || now.isSameOrAfter(start, 'day')) && (!end || now.isSameOrBefore(end, 'day'));
            });
        } else if (statusFilter === 2) { // Sắp diễn ra
            displayData = displayData.filter((x) => {
                const start = x.tu_ngay ? moment(x.tu_ngay) : null;
                return start && now.isBefore(start, 'day');
            });
        } else if (statusFilter === 3) { // Hết hạn
            displayData = displayData.filter((x) => {
                const end = x.den_ngay ? moment(x.den_ngay) : null;
                return end && now.isAfter(end, 'day');
            });
        }

        return displayData.map(x => {
            const count = sf_mucphaithu_miengiams.filter(y => y.sf_hinhthucmiengiam_id == x.id).length;
            return { ...x, is_selected: count > 0 };
        });
    }, [sf_hinhthucmiengiams, sf_mucphaithu_miengiams, statusFilter])

    const handleSubmit = async () => {
        SetIsSaving(true)
        const data = sf_hinhthucmiengiams.map(x => {
            return {
                ...x,
                so_chung_tu: props.sf_mucphaithu.so_chung_tu,
                sf_mucphaithu_id: props.sf_mucphaithu.id,
                ma_hinhthucmiengiam: x.ma_hinh_thuc,
                is_selected: sf_hinhthucmiengiam_selected_ids.includes(x.id)
            };
        });
        const res = await thuPhiApi.save_miengiams(data);
        if (res.is_success) {
            props.onChanged()
            showNotify({ message: "Cập nhật thành công", type: "success" });
        } else {
            showNotify({ message: res.message || "Cập nhật thất bại", type: "error" });
        }
        SetIsSaving(false)
    }
    const onClose = useCallback(() => {
        window.animationHidePopup("")
        setTimeout(() => {
            props.onClose();
        }, 500);
    }, [])
    return (
        <div>
            <DefaultPopup title="Điều chỉnh chiết khấu" maxWidth={900} width='80%' onClose={onClose}>
                <div className="pop-up-form">
                    <Box sx={{ mb: 2 }}>
                        <SegmentedControl size="small" sx={{ width: "fit-content" }}>
                            <SegmentedControl.Button
                                selected={statusFilter === 0}
                                onClick={() => setStatusFilter(0)}
                            >
                                Tất cả
                            </SegmentedControl.Button>
                            <SegmentedControl.Button
                                selected={statusFilter === 1}
                                onClick={() => setStatusFilter(1)}
                            >
                                Khả dụng
                            </SegmentedControl.Button>
                            <SegmentedControl.Button
                                selected={statusFilter === 2}
                                onClick={() => setStatusFilter(2)}
                            >
                                Sắp diễn ra
                            </SegmentedControl.Button>
                            <SegmentedControl.Button
                                selected={statusFilter === 3}
                                onClick={() => setStatusFilter(3)}
                            >
                                Hết hạn
                            </SegmentedControl.Button>
                        </SegmentedControl>
                    </Box>
                    <DataGrid
                        keyExpr={"id"}
                        dataSource={dataSource}
                        columns={columns}
                        height={window.innerHeight - 240}
                        selection={{
                            mode: "multiple",
                            selectedRowKeys: sf_hinhthucmiengiam_selected_ids,
                            onSelectionChanged: onSelectionChanged,
                            isRowSelectionDisabled: (data) => data.tu_ngay && moment(data.tu_ngay).isAfter(moment(), 'day')
                        }}
                        paging={{ enable: false }}
                        grouping={{
                            enable: true,
                            groupField: "ten_nhom_mien_giam"
                        }}
                        filterRow={{ enable: true }}
                    />
                </div>
                <div className="pop-up-actions">
                    <Button text="Đóng" icon="fa fa-times" onClick={() => { props.onClose() }} />{' '}
                    <Button text="Áp dụng" type="normal" icon="fas fa-check-square" onClick={handleSubmit} isLoading={isSaving} />
                </div>
            </DefaultPopup>
        </div>
    );
}
export default ThuPhiDieuChinhChietKhauBtn
